// Delegate to the global singleton to ensure only one AudioContext exists
import { getCtx } from '../ctxSingleton';

export function getSharedAudioContext(): AudioContext {
  return getCtx();
}

export {}; // keep as module under --isolatedModules
